import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfirmationService {
  private confirmationSubject = new Subject<boolean>();

  constructor() {}

  confirm(message: string): Observable<boolean> {
    const confirmation = window.confirm(message);
    this.confirmationSubject.next(confirmation);
    return this.confirmationSubject.asObservable();
  }
}
